import React from 'react';
import ProductList from '../../components/ProductList';
import {
  StyledHeading,
  StyledWrap,
  StyledButton,
  StyledBlocks,
  SectionWrapper
} from "./styles";
import { SectionSettings, Product } from "../../interfaces/sanity";

interface Props {
  data: {
    button: {
      enabled: boolean;
      text: string;
      link: string;
    };
    firstLarge?: boolean;
    showAddToCart?: boolean;
    // showDescription?: boolean;
    products: Product[];
    productsWithLabel: {
      product: Product[];
      text: string;
      bgColor: any;
      textColor: any;
    }
    sectionSettings: SectionSettings;
    heading: any;
    buttonsInBlack?: boolean;
    hasSmallTopPadding?: boolean;
    hasSmallBottomPadding?: boolean;
  };
}

const ProductListSection = ({ data }: Props) => {
  const { button, heading, products, firstLarge = false, showAddToCart, productsWithLabel, buttonsInBlack, hasSmallTopPadding = false, hasSmallBottomPadding = false } = data;
  return (
    <SectionWrapper>
      <StyledWrap hasSmallTopPadding={hasSmallTopPadding} hasSmallBottomPadding={hasSmallBottomPadding}>
        {heading && <StyledBlocks blocks={heading} />}
        <ProductList
          products={productsWithLabel ? productsWithLabel : products}
          firstLarge={firstLarge}
          addToCart={showAddToCart}
          showRating={true}
          buttonsInBlack={buttonsInBlack}
        />
        {button?.enabled && (
          <StyledButton
            buttonType={button.type ? button.type : 'outline'}
            to={button.link}
          >
            {button.text}
          </StyledButton>
        )}
      </StyledWrap>
    </SectionWrapper>
    
  );
};

export default ProductListSection;
